const HTML_ENTITIES = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
};

/**
 * Escape an arbitrary value before interpolating it into an HTML string.
 *
 * Vue templates escape text automatically, but consumers such as ApexCharts
 * custom tooltips and print windows accept raw HTML and therefore need an
 * explicit boundary.
 */
export function escapeHtml(value) {
    return String(value ?? '').replace(
        /[&<>"']/g,
        (character) => HTML_ENTITIES[character],
    );
}

/**
 * Prefixed database id used by global search (e.g. SA-42, PO-7, CUS-15).
 * Pass the entity prefix including the trailing hyphen.
 */
export function searchRef(prefix, id) {
    if (id === null || id === undefined || id === '') {
        return '';
    }

    return `${prefix}${id}`;
}
